import { useEffect, useRef } from "react";

// useEffect()内で過去のstateの値を知りたくなった場合、このHookが利用できる
// ref: https://labex.io/ja/tutorials/react-react-useprevious-hook-38404
export const usePrevious = <T>(value: T): T => {
  const ref = useRef<T>(value);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
